/** Shopify CDN: Minification failed

Line 55:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 84:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 85:4 Transforming const to the configured target environment ("es5") is not supported yet

**/

try {
  var swiperOptions = {
    freeMode: true,
    loop: true,
    slidesPerView: "auto",
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 25000,
  };

  var swiper = new Swiper(".text-animation", swiperOptions);
  swiper.mousewheel.disable();
  function display_slide(event) {
    event.preventDefault();
    let slideIndex = event.currentTarget.getAttribute("data-index");
    const swiper = document.querySelector(".section_images").swiper;
    swiper.slideTo(slideIndex, 200, true);
  }

  let w = window.innerWidth;

  if (w < 991) {
    var swiper_make = new Swiper(".make-carousel", {
      slidesPerView: "auto",
      spaceBetween: 0,
      slidesPerGroupSkip: 1,
    });
  } else {
    gsap.registerPlugin(ScrollTrigger);

    const sections = gsap.utils.toArray(".section-slide");
    let maxWidth = 0;

    const getMaxWidth = () => {
      maxWidth = 0;
      sections.forEach((section) => {
        maxWidth += section.offsetWidth;
      });
    };
    getMaxWidth();
    ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

    /* replaced maxWidth in end() for new var */
    var howFastScroll = 1000;

    gsap.to(sections, {
      x: () => `-${maxWidth - window.innerWidth}`,
      ease: "none",
      scrollTrigger: {
        trigger: ".section-natural",
        pin: true,
        scrub: true,
        end: () => `+=${howFastScroll}`,
        invalidateOnRefresh: true,
      },
    });

    sections.forEach((sct, i) => {
      ScrollTrigger.create({
        trigger: sct,
        start: () =>
          "top top-=" +
          (sct.offsetLeft - window.innerWidth / 2) *
            (maxWidth / (maxWidth - window.innerWidth)),
        end: () =>
          "+=" + sct.offsetWidth * (maxWidth / (maxWidth - window.innerWidth)),
        toggleClass: { targets: sct, className: "active" },
      });
    });
  }

  window.addEventListener("scroll", (event) => {
    var element = document.getElementById("gorgias-chat-widget-install-v2");

    if (typeof element != "undefined" && element != null) {
    } else {
      var gorgiasWidget = document.createElement("script");
      gorgiasWidget.setAttribute(
        "src",
        "https://config.gorgias.chat/gorgias-chat-bundle-loader.js?applicationId=12827"
      );
      gorgiasWidget.defer = true;
      gorgiasWidget.id = "gorgias-chat-widget-install-v2";
      document.head.appendChild(gorgiasWidget);

      setTimeout(function () {
        !(function (_) {
          (_.SHOPIFY_PERMANENT_DOMAIN = "{{shop.permanent_domain}}"),
            (_.SHOPIFY_CUSTOMER_ID = "{{customer.id}}"),
            (_.SHOPIFY_CUSTOMER_EMAIL = "{{customer.email}}");
        })(window || {});
      }, 500);
    }
  });
  if (window.innerWidth < 991) {
    var swiper_make = new Swiper(".make-carousel", {
      slidesPerView: 1,
      spaceBetween: 30,
      slidesPerGroupSkip: 1,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".swiper-button-next-make",
        prevEl: ".swiper-button-prev-make",
      },
      pagination: {
        el: ".swiper-pagination-make",
        clickable: true,
      },
    });
    var swiper_related = new Swiper(".related-carousel", {
      slidesPerView: "auto",
      spaceBetween: 30,
      slidesPerGroupSkip: 1,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".swiper-button-next-related",
        prevEl: ".swiper-button-prev-related",
      },
    });
    var swiper_difference = new Swiper(".difference-carousel", {
      slidesPerView: 1,
      spaceBetween: 30,
      slidesPerGroupSkip: 1,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".swiper-button-next-difference",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination-difference",
        clickable: true,
      },
    });
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      const tl = gsap
        .timeline()
        .to(
          ".dot-step",
          {
            background: "#D29C7D",
            ease: "none",
            duration: 1,
            opacity: 1,
            stagger: 1.15,
          },
          0
        )
        .to(
          ".feature-item",
          {
            opacity: 1,
            ease: "linear",
            duration: 1,
            stagger: 1.15,
          },
          0
        )
        .to(
          ".feature-item .diffternt-text",
          {
            css: {
              className: "+= ps-5 diffternt-text active",
            },
            ease: "linear",
            duration: 1,
            stagger: 1.5,
          },
          0
        )
        .from(
          ".bg-bar",
          {
            height: 0,
            ease: "linear",
            duration: 1,
            stagger: 1,
          },
          1
        );

      const controller = new ScrollMagic.Controller();
      const scene = new ScrollMagic.Scene({
        triggerElement: ".items-container",
        triggerHook: 0.5,
        offset: 0,
        duration: "825",
      })
       // .setTween(tl)
        .addTo(controller);
    });
  }
} catch (error) {}
